const DEFAULT_POLICY_DOCUMENT_TYPE = (documentTypes = []) => {
  const sorted = [...documentTypes].sort((a, b) => (a.sort ?? Number.MAX_SAFE_INTEGER) - (b.sort ?? Number.MAX_SAFE_INTEGER));
  return sorted[0] || null;
};

const getPolicyDocumentTypes = (policyForms = {}) => {
  const source = Array.isArray(policyForms)
    ? policyForms
    : policyForms || {};

  const candidates = [
    Array.isArray(source?.['policy-document-types']) ? source['policy-document-types'] : null,
    Array.isArray(source?.['policy_document_types']) ? source.policy_document_types : null,
    Array.isArray(source?.['document-types']) ? source['document-types'] : null,
    Array.isArray(source?.['document_types']) ? source.document_types : null,
    Array.isArray(source) ? source : null,
  ].filter(Boolean);

  const documentTypes = candidates.find(Array.isArray) || [];
  return [...documentTypes].sort((a, b) => (a.sort ?? Number.MAX_SAFE_INTEGER) - (b.sort ?? Number.MAX_SAFE_INTEGER));
};

const normalizePolicyAttachment = (file, documentTypes = []) => {
  const safeFile = file || {};
  const normalizedFileName = safeFile.name || 'file';
  const extension = normalizedFileName.split('.').pop()?.toLowerCase();
  const defaultDocumentType = DEFAULT_POLICY_DOCUMENT_TYPE(documentTypes);

  return {
    id: safeFile.id ?? `${normalizedFileName}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    name: normalizedFileName,
    type: extension === 'jpg' || extension === 'png' || extension === 'svg' ? 'image' : extension || 'file',
    file: safeFile,
    documentTypeId: defaultDocumentType?.id ?? null,
    documentType: defaultDocumentType || null,
  };
};

const mergePolicyAttachments = (existing = [], incoming = []) => {
  if (!Array.isArray(existing)) return Array.isArray(incoming) ? [...incoming] : [];
  if (!Array.isArray(incoming)) return [...existing];
  return [...existing, ...incoming];
};

module.exports = {
  DEFAULT_POLICY_DOCUMENT_TYPE,
  getPolicyDocumentTypes,
  normalizePolicyAttachment,
  mergePolicyAttachments,
};
